
{
  "familyId": "REK-CONTEXT-PLUS-MIN",
  "questions": [
    {
      "id": "REK-CONTEXT-PLUS-MIN-001",
      "familyId": "REK-CONTEXT-PLUS-MIN",
      "module": "Basisrekenen",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_optellen_aftrekken",
      "questionType": "multiple_choice",
      "question": "Een schilder koopt 12 blikken verf van 2,5 liter. Na het schilderen van een huis heeft ze nog 8,5 liter over. Hoeveel liter verf heeft ze gebruikt?",
      "options": ["21,5 liter", "30 liter", "22,5 liter", "20 liter"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Twee stappen: eerst totaal, dan aftrekken",
            "content": "Stap 1: Hoeveel verf in totaal? 12 × 2,5 = 30 liter. Stap 2: Hoeveel gebruikt? 30 − 8,5 = 21,5 liter. Tip: lees de vraag goed — er wordt gevraagd hoeveel ze GEBRUIKT heeft, niet hoeveel ze HEEFT.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "context_plus_min_tweestaps",
      "variantIndex": 1,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "Stap 1: Totaal verf = 12 × 2,5 = 30 liter. Stap 2: Gebruikt = totaal − over = 30 − 8,5 = 21,5 liter. Let op: de vraag is 'hoeveel gebruikt', dus je trekt het restant af van het totaal.",
        "solutionSteps": [
          "Stap 1: Totaal verf = 12 × 2,5 = 30 liter",
          "Stap 2: Gebruikt = totaal − over",
          "30 − 8,5 = 21,5 liter"
        ],
        "distractorExplanations": {
          "0": "Goed! 12 × 2,5 = 30 liter totaal, min 8,5 liter over = 21,5 liter gebruikt.",
          "1": "Je berekende het totaal (12 × 2,5 = 30 liter), maar vergat de 8,5 liter die over is af te trekken. De vraag is hoeveel ze GEBRUIKT heeft: 30 − 8,5 = 21,5.",
          "2": "Je dacht waarschijnlijk 30 − 7,5 = 22,5. Maar er is 8,5 liter over, niet 7,5. 30 − 8,5 = 21,5 liter.",
          "3": "Je dacht waarschijnlijk 12 × 2,5 = 30, dan 30 − 10 = 20. Maar er is 8,5 liter over, niet 10. 30 − 8,5 = 21,5 liter."
        }
      }
    },
    {
      "id": "REK-CONTEXT-PLUS-MIN-002",
      "familyId": "REK-CONTEXT-PLUS-MIN",
      "module": "Basisrekenen",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_optellen_aftrekken",
      "questionType": "multiple_choice",
      "question": "Een magazijnmedewerker telt de voorraad. 's Ochtends zijn er 1.250 dozen. Er worden 387 dozen uitgeleverd en later komen er 145 dozen bij. Hoeveel dozen zijn er aan het eind van de dag?",
      "options": ["1.008 dozen", "1.782 dozen", "863 dozen", "1.108 dozen"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Lees de richting: erbij of eraf?",
            "content": "Uitgeleverd = eraf (aftrekken). Bijkomen = erbij (optellen). Reken: 1.250 − 387 = 863, dan 863 + 145 = 1.008. Tip: markeer in de tekst wat erbij komt (+) en wat eraf gaat (−).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "context_plus_min_voorraad",
      "variantIndex": 2,
      "citoDifficulty": 0.44,
      "citoDiscrimination": 0.80,
      "feedback": {
        "explanationText": "Uitgeleverd = eraf: 1.250 − 387 = 863. Bijkomen = erbij: 863 + 145 = 1.008 dozen. Tip: markeer in de tekst wat erbij komt (+) en wat eraf gaat (−). Dat helpt bij het kiezen van de juiste bewerking.",
        "solutionSteps": [
          "Begin: 1.250 dozen",
          "Uitgeleverd (−): 1.250 − 387 = 863",
          "Bijgekomen (+): 863 + 145 = 1.008",
          "Eind: 1.008 dozen"
        ],
        "distractorExplanations": {
          "0": "Goed! 1.250 − 387 + 145 = 1.008 dozen aan het eind van de dag.",
          "1": "Je telde alles bij elkaar op: 1.250 + 387 + 145 = 1.782. Maar 387 dozen werden UITGELEVERD — dat is aftrekken, niet optellen.",
          "2": "Je berekende 1.250 − 387 = 863, maar vergat de 145 dozen die later bijkwamen. 863 + 145 = 1.008.",
          "3": "Je dacht waarschijnlijk 1.250 − 387 + 145 = 1.108. Controleer je berekening: 1.250 − 387 = 863, dan 863 + 145 = 1.008."
        }
      }
    },
    {
      "id": "REK-CONTEXT-PLUS-MIN-003",
      "familyId": "REK-CONTEXT-PLUS-MIN",
      "module": "Basisrekenen",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_optellen_aftrekken",
      "questionType": "multiple_choice",
      "question": "Een verpleegkundige werkt drie diensten deze week: maandag 8 uur en 45 minuten, woensdag 7 uur en 30 minuten, en vrijdag 9 uur en 15 minuten. Hoeveel uur en minuten werkt ze in totaal?",
      "options": ["25 uur en 30 minuten", "24 uur en 90 minuten", "25 uur en 90 minuten", "24 uur en 30 minuten"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Uren en minuten apart optellen",
            "content": "Tel de uren apart: 8 + 7 + 9 = 24 uur. Tel de minuten apart: 45 + 30 + 15 = 90 minuten. 90 minuten = 1 uur en 30 minuten. Totaal: 24 + 1 = 25 uur en 30 minuten.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "context_plus_min_tijd_optellen",
      "variantIndex": 3,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Uren: 8 + 7 + 9 = 24 uur. Minuten: 45 + 30 + 15 = 90 minuten = 1 uur en 30 minuten. Totaal: 24 + 1 = 25 uur en 30 minuten. Let op: 90 minuten is meer dan 1 uur, dus je moet omrekenen!",
        "solutionSteps": [
          "Uren optellen: 8 + 7 + 9 = 24 uur",
          "Minuten optellen: 45 + 30 + 15 = 90 minuten",
          "Omrekenen: 90 min = 1 uur en 30 min",
          "Totaal: 24 + 1 = 25 uur en 30 minuten"
        ],
        "distractorExplanations": {
          "0": "Goed! 24 uur + 90 minuten = 25 uur en 30 minuten.",
          "1": "Je telde de uren (24) en minuten (90) goed op, maar vergat om te rekenen. 90 minuten = 1 uur en 30 minuten. Dus 24 uur + 1 uur en 30 min = 25 uur en 30 min.",
          "2": "Je telde 25 uur en 90 minuten. Maar 90 minuten moet je omrekenen: 90 min = 1 uur en 30 min. Dus 25 + 1 = 26 uur en 30 min? Nee — de uren zijn 24, niet 25. 24 + 1 = 25 uur en 30 min.",
          "3": "Je dacht waarschijnlijk 24 uur en 30 minuten. Maar de minuten zijn 45 + 30 + 15 = 90, niet 30. 90 min = 1 uur en 30 min, dus totaal 25 uur en 30 min."
        }
      }
    },
    {
      "id": "REK-CONTEXT-PLUS-MIN-004",
      "familyId": "REK-CONTEXT-PLUS-MIN",
      "module": "Basisrekenen",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_optellen_aftrekken",
      "questionType": "multiple_choice",
      "question": "Een kassamedewerker telt de kassa op. Er zit €487,50 in de kassa. Vandaag is er €1.235,75 ontvangen en €362,80 wisselgeld teruggegeven. Hoeveel zit er nu in de kassa?",
      "options": ["€1.360,45", "€1.723,25", "€2.086,05", "€1.598,25"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Ontvangen = erbij, teruggegeven = eraf",
            "content": "Begin: €487,50. Ontvangen (+): €487,50 + €1.235,75 = €1.723,25. Wisselgeld (−): €1.723,25 − €362,80 = €1.360,45. Tip: 'ontvangen' = optellen, 'teruggeven' = aftrekken.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "context_plus_min_geld_kassa",
      "variantIndex": 4,
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.82,
      "feedback": {
        "explanationText": "Begin: €487,50. Ontvangen (+): 487,50 + 1.235,75 = 1.723,25. Wisselgeld terug (−): 1.723,25 − 362,80 = 1.360,45. Er zit nu €1.360,45 in de kassa.",
        "solutionSteps": [
          "Begin: €487,50",
          "Ontvangen (+): 487,50 + 1.235,75 = 1.723,25",
          "Wisselgeld (−): 1.723,25 − 362,80 = 1.360,45"
        ],
        "distractorExplanations": {
          "0": "Goed! €487,50 + €1.235,75 − €362,80 = €1.360,45.",
          "1": "Je berekende €487,50 + €1.235,75 = €1.723,25, maar vergat het wisselgeld af te trekken. Er is €362,80 teruggegeven: 1.723,25 − 362,80 = 1.360,45.",
          "2": "Je telde alles bij elkaar op: 487,50 + 1.235,75 + 362,80 = 2.086,05. Maar wisselgeld wordt TERUGGEGEVEN — dat is aftrekken, niet optellen.",
          "3": "Je dacht waarschijnlijk 1.235,75 + 362,80 = 1.598,55 ≈ 1.598,25. Maar je moet beginnen bij €487,50 en het wisselgeld aftrekken, niet optellen."
        }
      }
    },
    {
      "id": "REK-CONTEXT-PLUS-MIN-005",
      "familyId": "REK-CONTEXT-PLUS-MIN",
      "module": "Basisrekenen",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_optellen_aftrekken",
      "questionType": "multiple_choice",
      "question": "Een boekhandelaar heeft 3 kasten met boeken. In de eerste kast staan 248 boeken, in de tweede 175 boeken en in de derde 312 boeken. Ze verkoopt er 89. Hoeveel boeken heeft ze nog?",
      "options": ["646", "735", "624", "736"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Eerst optellen, dan aftrekken",
            "content": "Stap 1: Tel alle boeken op: 248 + 175 + 312 = 735. Stap 2: Trek de verkochte boeken af: 735 − 89 = 646. Tip: tel eerst alles bij elkaar op, trek dan af wat weg is.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "context_plus_min_meerdere_optellen",
      "variantIndex": 5,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Totaal: 248 + 175 + 312 = 735 boeken. Verkocht: 735 − 89 = 646 boeken over. Tip: bij dit soort opgaven tel je eerst alles op en trek je daarna af wat weg is.",
        "solutionSteps": [
          "Stap 1: 248 + 175 = 423",
          "Stap 2: 423 + 312 = 735 boeken totaal",
          "Stap 3: 735 − 89 = 646 boeken over"
        ],
        "distractorExplanations": {
          "0": "Goed! 248 + 175 + 312 = 735, dan 735 − 89 = 646 boeken.",
          "1": "Je berekende het totaal (735) maar vergat de 89 verkochte boeken af te trekken. De vraag is hoeveel ze NOG heeft: 735 − 89 = 646.",
          "2": "Je dacht waarschijnlijk 735 − 111 = 624. Maar er zijn 89 boeken verkocht, niet 111. 735 − 89 = 646.",
          "3": "Je dacht waarschijnlijk 248 + 175 + 312 = 736. Controleer: 248 + 175 = 423, dan 423 + 312 = 735 (niet 736). Dan 735 − 89 = 646."
        }
      }
    }
  ]
}
